import { useEffect, useRef } from 'react';

/**
 * 주어진 시간 간격으로 콜백 함수를 실행하는 커스텀 훅
 * @param callback 실행할 콜백 함수
 * @param delay 실행 간격 (ms)
 * @param isActive 실행 여부
 */
const useInterval = (callback: () => void, delay: number, isActive = true) => {
  const savedCallback = useRef<() => void>(undefined);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    const executeCallback = () => {
      savedCallback.current?.();
    };

    const id = setInterval(executeCallback, delay);

    if (!isActive) {
      clearInterval(id);
    }

    return () => clearInterval(id);
  }, [isActive]);
};

export default useInterval;
